import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.654 12.868c-.171.512-.256 1.173-.256 1.983V15h2.564v-.149c0-.569.1-1.023.299-1.364.199-.355.449-.661.748-.917.299-.27.62-.512.961-.725.356-.213.684-.462.983-.746.299-.298.548-.661.748-1.087S17 9.038 17 8.371a4.13 4.13 0 0 0-.363-1.748 3.957 3.957 0 0 0-1.026-1.386 4.346 4.346 0 0 0-1.56-.917A5.89 5.89 0 0 0 12.064 4c-1.339 0-2.429.291-3.269.874A4.968 4.968 0 0 0 7 7.155l2.65 1.13a2.87 2.87 0 0 1 .812-1.215c.385-.327.876-.49 1.474-.49.627 0 1.125.171 1.496.512.385.341.577.775.577 1.3 0 .398-.093.725-.278.981-.171.256-.392.49-.662.704-.271.199-.563.412-.876.639a4.03 4.03 0 0 0-.855.853c-.271.341-.499.775-.684 1.3zM11.75 19.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z" />
  </svg>
);

export default SvgQuestion;
